<template>
  <div class="relative flex flex-col justify-center items-center -ml-100 w-5/12 rounded-2xl bg-white py-10">
    <span @click="closeModal" class="absolute left-8 top-4 mb-5 text-customGray text-sm cursor-pointer">Close</span>
    <h2 class="text-center font-semibold text-xl mb-2 text-yank">Your groups have been added!</h2>
    <p class="text-customGray text-center text-sm font-light w-8/12 mb-6">If you don’t want these groups to show in Media Scheduler, you can toggle them On and Off in settings</p>
    <form class="flex flex-col md:flex-row px-5" @submit.prevent="submit" >
        <button @click="closeModal" class="w-12/12 px-8 py-2 text-sm border-payneHot border-2 rounded-lg mr-2 mb-2 md:mb-0" type="button">Back to settings</button>
        <button class="w-12/12 px-10 py-2 text-sm bg-payneHot rounded-lg text-white" type="submit">Go to Scheduler</button> 
    </form>
</div>
</template>

<script>
export default {
    name:"ConfirmGroupModal",

    methods: {
        closeModal() {
            this.$emit('closeModal')
        }
    },
}
</script>

<style>

</style>